import React from "react";
import { motion } from "framer-motion";
import {
  FiX,
  FiCheck,
  FiRefreshCw,
  FiDollarSign,
  FiGlobe,
  FiMapPin,
  FiClock,
} from "react-icons/fi";
import {
  FORMAT_OPTIONS,
  PRICING_OPTIONS,
  STATUS_OPTIONS,
} from "../utils/constants";
import "./WSPFilterPanel.css";

/**
 * WSPFilterPanel - Collapsible Filter Panel
 */
const WSPFilterPanel = ({
  filters,
  onFilterChange,
  onClearFilters,
  onClose,
  categories = [],
}) => {
  const hasActiveFilters = Object.entries(filters).some(
    ([key, value]) =>
      value !== null &&
      value !== "all" &&
      !["sortBy", "sortOrder"].includes(key)
  );

  return (
    <motion.div
      className="wsp-filter-panel"
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="wsp-filter-panel-inner">
        <div className="wsp-filter-panel-header">
          <h3 className="wsp-filter-panel-title">Filters</h3>
          <div className="wsp-filter-panel-actions">
            {hasActiveFilters && (
              <button className="wsp-filter-clear" onClick={onClearFilters}>
                <FiRefreshCw size={14} />
                Clear All
              </button>
            )}
            <button className="wsp-filter-close" onClick={onClose}>
              <FiX size={20} />
            </button>
          </div>
        </div>

        <div className="wsp-filter-grid">
          {/* Format Filter */}
          <div className="wsp-filter-group">
            <label className="wsp-filter-label">Format</label>
            <div className="wsp-filter-options">
              {FORMAT_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  className={`wsp-filter-option ${
                    filters.format === option.value ? "active" : ""
                  }`}
                  onClick={() => onFilterChange("format", option.value)}
                >
                  {option.value === "online" && <FiGlobe size={14} />}
                  {option.value === "physical" && <FiMapPin size={14} />}
                  {option.label}
                  {filters.format === option.value && <FiCheck size={14} />}
                </button>
              ))}
            </div>
          </div>

          {/* Pricing Filter */}
          <div className="wsp-filter-group">
            <label className="wsp-filter-label">Price</label>
            <div className="wsp-filter-options">
              {PRICING_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  className={`wsp-filter-option ${
                    filters.pricing === option.value ? "active" : ""
                  }`}
                  onClick={() => onFilterChange("pricing", option.value)}
                >
                  <FiDollarSign size={14} />
                  {option.label}
                  {filters.pricing === option.value && <FiCheck size={14} />}
                </button>
              ))}
            </div>
          </div>

          {/* Status Filter */}
          <div className="wsp-filter-group">
            <label className="wsp-filter-label">Status</label>
            <div className="wsp-filter-options">
              {STATUS_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  className={`wsp-filter-option ${
                    filters.status === option.value ? "active" : ""
                  }`}
                  onClick={() => onFilterChange("status", option.value)}
                >
                  <FiClock size={14} />
                  {option.label}
                  {filters.status === option.value && <FiCheck size={14} />}
                </button>
              ))}
            </div>
          </div>

          {/* Category Filter */}
          {categories.length > 0 && (
            <div className="wsp-filter-group wsp-filter-group-wide">
              <label className="wsp-filter-label">Category</label>
              <div className="wsp-filter-categories">
                <button
                  className={`wsp-filter-category ${
                    filters.category === "all" ? "active" : ""
                  }`}
                  onClick={() => onFilterChange("category", "all")}
                >
                  All Categories
                </button>
                {categories.map((category) => (
                  <button
                    key={category.name}
                    className={`wsp-filter-category ${
                      filters.category === category.name ? "active" : ""
                    }`}
                    onClick={() => onFilterChange("category", category.name)}
                  >
                    {category.name}
                    <span className="wsp-category-count">{category.count}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default WSPFilterPanel;
